module.exports = __webpack_public_path__ + "img/pdf.b5f019af.gif";